module.exports = __webpack_public_path__ + "img/rightpop-bg.8729f7c3.png";